import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { TagModule } from 'primeng/tag';
import { FormsModule } from '@angular/forms';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';
import { Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { BillingService } from './../../../../../glamera-booking-link/src/app/core/services/billing.service';
import { SideDialogService } from '@s-app/common/services';
import { Invoice, BillingItem } from '@bl-src/app/core/models/invoice.model';
import Swal from 'sweetalert2';
import { SharedService } from '@s-app/common/services/shared.service';
import { BranchService } from '@bl-src/app/core/services/branch.service';
import jsPDF from 'jspdf';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { PaymentMethod, PaymentMethodDialogCloseData } from '@s-app/subscripion-plans/subscribe-page/payment-method-dialog/payment-method-dialog.component';
import { PaymentMethodDialogData } from '@s-app/subscripion-plans/subscribe-page/payment-method-dialog/payment-method-dialog.component';
import { PaymentMethodDialogComponent } from '@s-app/subscripion-plans/subscribe-page/payment-method-dialog/payment-method-dialog.component';
import { DialogService } from 'primeng/dynamicdialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService, TreeNode } from 'primeng/api';
import { CommonModule } from '@node_modules/@angular/common';
import { DropdownModule } from 'primeng/dropdown';
import { PaginationV2Component } from '@s-app/shared/pagination-v2/pagination-v2.component';
import { CalendarModule } from 'primeng/calendar';



@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  standalone:true,
  imports: [
    CommonModule,
    TranslateModule,
    TableModule,
    FormsModule,
    SkeletonModule,
    DropdownModule,
    TagModule,
    ToastModule,
    InputTextModule,
    PaginationV2Component,
    CalendarModule
  ],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService, DynamicDialogRef,MessageService],
  styleUrls: ['./invoices.component.scss'],
})
export class InvoicesComponent implements OnInit {
  @Input()
  public branch: any | null = null;
  public branches: any []=[];
  dateFillter:any;
  @ViewChild('invioceDetails')
  public invioceDetails!: ElementRef;

  public invoices: Invoice[] = [];
  count: number;
  page = 0;
  rows = 5; // default page number

  public invoicesData: any[];
  public originalInvoices: Invoice[] = [];
  public selectedInvoice: Invoice | undefined;
  public selectedBillingItems: number[]=[];
  public selectedPaymentMethod: PaymentMethod = PaymentMethod.Mada;
  public showPaymentPopup: boolean = false;
  public isPrimaryButton: boolean = false;
  public expandedInvoices: { [key: string]: boolean } = {};
  public ref: DynamicDialogRef | undefined;
  isLoading:boolean = false;
  constructor(
    public billingService: BillingService,
    private  branchService: BranchService,
    private sideDialogService: SideDialogService,
    public sharedService: SharedService,
    private dialogService: DialogService,
    private translate: TranslateService,
    private messageService: MessageService
  ) {}
  filters:{BranchId:number|null,DateTime:string|null,FreeText:string|null} = {
    FreeText:null,
    BranchId:null,
    DateTime:null
  }
  currentDate:Date = new Date();
  tableHeader:string[]=[
    '',
    'translate_the_invoice',
    'Status',
    'translate_the_date',
    'translate_the_price',
    'translate_actions'
  ]
  expandTableHeader:string[]=[
    '',
    'translate_the_invoice',
    'Cycle',
    'translate_the_date',
    'translate_the_branch',
    'translate_the_price',
    'Status',
  ]

  selectedBranch: { id: number, name: string };
  searchValue:string = '';

  ngOnInit() {
    this.showInvoices();
    this.getAllBranches();
  }

  public showInvoices(): void {
    this.isLoading = true;
    this.billingService.getBillings(this.page, this.rows,this.filters).subscribe(
      (data: any) => {
       this.isLoading = false;
        this.invoices = data.result;
        this.originalInvoices = data.result ;
        this.count = data.totalItemsCount
      },
      (error: any) => {
        this.isLoading = false;
        console.error('Error fetching billings:', error);
      }
    );
  }

  paginationSetResponse(res: any) {
    this.invoices = res.result;
  }

  submitFilter():void{
    this.showInvoices();
  }
  public getAllBranches(): void {
    this.branchService.getAllLiteBranches().subscribe(
      (data:  any ) => {
          this.branches=data;
      },
      (error: any) => {
        console.error('Error fetching billings:', error);
      }
    );
  }

  public searchFreeText(value:string): void {
      this.invoices = this.originalInvoices.filter((invoice) =>
        invoice.billingItems.some(i=>   i.title?.toLowerCase().includes(value.toLowerCase()) || i.invoiceNo.toString().toLowerCase().includes(value.toLowerCase()) )
    || invoice.code.toString().toLowerCase().includes(value.toLowerCase()
    ));
  }

  public searchBranchId($event:any): void {
    let branchId = $event.target.value;
      this.invoices = this.originalInvoices.filter((invoice) => invoice.billingItems.some(i=>i.branchId == branchId));
  }
  searchedBranch:string | null;
  public searchBranch(id:any,name:string|null): void {
    let branchId = id;
    if(branchId==-1){
      this.searchedBranch=null;
      this.invoices = this.originalInvoices;
      return;
    }
    this.searchedBranch=name;
      this.invoices = this.originalInvoices.filter((invoice) => invoice.billingItems.some(i=>i.branchId == branchId));

  }

  public searchMonths($event:any): void {
    let date = $event.target.value;
    let month = new Date(date).getMonth() + 1;
    let year =  new Date(date).getFullYear();

      this.invoices = this.originalInvoices.filter((invoice) => invoice.billingItems.some(i=>i.billingDate
        && new Date(i.billingDate).getMonth() + 1 == month
        && new Date(i.billingDate).getFullYear() == year));

  }


  openPaymentMethodDialog(invoice: Invoice, billingItem: BillingItem, branchId: number, isPrimaryButton: boolean): void {
    this.selectedInvoice = invoice;
    this.isPrimaryButton = isPrimaryButton;
    const header = localStorage.getItem('lang') === 'ar' ? 'اختر طريقة الدفع' : 'Select payment method';
    const title = localStorage.getItem('lang') === 'ar' ? 'دفع فاتورة' : 'Pay invoice'

    this.ref = this.dialogService.open(PaymentMethodDialogComponent, {
      header: header,
      width: '35vw',
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw'
    },
      data: {
        title: `${title} (${invoice.code})`,
        price: invoice.totalCost,
        currency: invoice.currency.code,
      } as PaymentMethodDialogData,
      contentStyle: { overflow: 'auto' },
      closeOnEscape: false,
      closable: false,
      styleClass: 'custom-dialog-style',
    });
    this.ref.onClose.subscribe((data: PaymentMethodDialogCloseData) => {
      if (data) {
        this.sharedService.isLoading = true;
        this.selectedPaymentMethod = data.PaymentMethodEnum;
       this.submitPaymentMethod();
      }
    });
  }

  selectBillingItem(event:any,billingId:number){
    if(event.target.checked){
      this.selectedBillingItems.push(billingId);

    }else{
      this.selectedBillingItems = this.selectedBillingItems.filter((item)=>item!=billingId);
    }


  }

  public submitPaymentMethod(): void {
    if (this.selectedPaymentMethod>=0 && this.selectedInvoice   ) {


      const paymentData =
      this.isPrimaryButton && this.selectedBillingItems.length>0
        ?
        {
          BillingIds: this.selectedBillingItems,
          PaymentMethodEnum: this.selectedPaymentMethod
        }
        :

        {
            BillingCode: this.selectedInvoice.code,
            PaymentMethodEnum: this.selectedPaymentMethod
          }
      ;


      this.billingService.postPayment(paymentData).subscribe(
        (response) => {
          if (response.paymentProviderURL) {
            this.sharedService.isLoading = false;
            window.location.href = response.paymentProviderURL;
          }
        },
        (error: any) => {
          this.sharedService.isLoading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error.error.message });
          console.error('Payment error:', error);
        }
      );
    } else {
    }
  }



  public closePaymentPopup(): void {
    this.showPaymentPopup = false;
  }




  public showInvoice(id: string): void {
    this.selectedInvoice = this.invoices.find((invoice) => invoice.code === id);
    if (!this.selectedInvoice) {
      return;
    }
    Swal.fire({
      html: this.invioceDetails.nativeElement,
      showConfirmButton: false,
      showCloseButton: true,
      closeButtonHtml:
        '<i class="fa-solid fa-xmark text-xl text-gray-800"></i>',
      width: 'min(47rem, 100%)',
      customClass: {
        htmlContainer: 'm-0',
        closeButton: 'absolute left-0',
      },
    });
  }

  public toggleInvoiceDetails(invoiceCode: string): void {
    this.expandedInvoices[invoiceCode] = !this.expandedInvoices[invoiceCode];
  }
  public async downloadAll(): Promise<void> {
    const zip = new JSZip();

    // Generate each invoice PDF and add to the ZIP
    for (const invoice of this.invoices) {
      const pdfData = await this.generateInvoicePdf(invoice);
      zip.file(`Invoice_${invoice.code}.pdf`, pdfData, { binary: true });
    }

    // Generate ZIP and trigger download
    zip.generateAsync({ type: 'blob' }).then((zipFile) => {
      saveAs(zipFile, 'Invoices.zip');
    });
  }

  // Function to generate invoice PDF and return it as binary data
  public generateInvoicePdf(invoice: Invoice): Promise<Blob> {
    return new Promise((resolve) => {
      const doc = new jsPDF();

      doc.setFontSize(16);
      doc.text('Invoice Details', 10, 10);
      doc.setFontSize(12);
      doc.text(`Invoice Number: ${invoice.code}`, 10, 20);
      doc.text(`Date: ${new Date(invoice.billingDate).toLocaleDateString()}`, 10, 30);
      doc.text(`Total Cost: ${invoice.totalCost.toFixed(2)} ${invoice.currency.code}`, 10, 40);
      doc.text(`Paid: ${invoice.isPaid ? 'Yes' : 'No'}`, 10, 50);

      doc.setFontSize(14);
      doc.text('Billing Items:', 10, 60);
      doc.setFontSize(12);

      invoice.billingItems.forEach((item, index) => {
        const position = 70 + (index * 10);
        doc.text(`- ${item.title}`, 10, position);
        doc.text(`Price: ${item.cost.toFixed(2)} ${item.currency.code}`, 100, position);
      });

      // Output the PDF as binary string data
      const pdfData = doc.output('blob'); // Create Blob from jsPDF
      resolve(pdfData);
    });
  }


  public downloadInvoiceAsPdf(invoice: Invoice): void {
    const doc = new jsPDF();

    doc.setFontSize(16);
    doc.text('Invoice Details', 10, 10);
    doc.setFontSize(12);
    doc.text(`Invoice Number: ${invoice.code}`, 10, 20);
    doc.text(`Date: ${new Date(invoice.billingDate).toLocaleDateString()}`, 10, 30);
    doc.text(`Total Cost: ${invoice.totalCost.toFixed(2)} ${invoice.currency.code}`, 10, 40);
    doc.text(`Paid: ${invoice.isPaid ? 'Yes' : 'No'}`, 10, 50);

    doc.setFontSize(14);
    doc.text('Billing Items:', 10, 60);
    doc.setFontSize(12);

    invoice.billingItems.forEach((item, index) => {
      const position = 70 + (index * 10);
      doc.text(`- ${item.title}`, 10, position);
      doc.text(`Price: ${item.cost.toFixed(2)} ${item.currency.code}`, 100, position);
    });

    doc.save(`Invoice_${invoice.code}.pdf`);
  }

}
